import useCustomerBaseActions from './useCustomerBaseActions'

export default useCustomerBaseActions
